import { RefObject, useEffect, useRef } from "react"
import { type FancyboxOptions, Fancybox } from "@fancyapps/ui/dist/fancybox"

/**
 * Fancybox custom hook
 * @see https://fancyapps.com/fancybox/integration/react/
 */
export function useFancyBox(
  options: Partial<FancyboxOptions> = {}
): [RefObject<HTMLElement | null>] {
  const container = useRef<HTMLElement>(null)

  useEffect(() => {
    if (container.current) {
      Fancybox.bind(container.current, "[data-fancybox]", options)

      return () => Fancybox.unbind(container.current)
    }
  }, [container, options])

  return [container]
}
